import React from 'react';
import Header from '../header';
import Footer from '../Footer';
import Careers from './careers'
import Banner from '../Pages/Banner'

function ContactUs(props) {
    return (
        <div>
            <Header />
            <Banner heading = {"Careers"}/>
            <Careers/>
            <Footer />
        </div>
    );
}

export default ContactUs;